'use strict';

// =================================================================================================================
// FVアニメーション
// =================================================================================================================
document.addEventListener("DOMContentLoaded", () => {
  const fv = document.querySelector("#fv"); // FVセクションを監視
  const targets = document.querySelectorAll(
    ".p-fv__logo.fv-fade-in, .p-fv__title.fv-fade-in, .p-fv__text.fv-fade-in"
  );

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        targets.forEach((el, i) => {
          setTimeout(() => {
            el.classList.add("show");
          }, i * 500); // 0ms → 500ms → 1000ms の順番
        });
        observer.unobserve(entry.target); // 一度だけ発火
      }
    });
  });

  observer.observe(fv);
});
'use strict';

// =================================================================================================================
// FVアニメーション
// =================================================================================================================
document.addEventListener("DOMContentLoaded", () => {
  const fv = document.querySelector("#fv"); // FVセクションを監視
  const targets = document.querySelectorAll(
    ".p-fv__logo.fv-fade-in, .p-fv__title.fv-fade-in, .p-fv__text.fv-fade-in"
  );

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        targets.forEach((el, i) => {
          setTimeout(() => {
            el.classList.add("show");
          }, i * 500); // 0ms → 500ms → 1000ms の順番
        });
        observer.unobserve(entry.target); // 一度だけ発火
      }
    });
  });

  observer.observe(fv);
});
